import { Component } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-toolbar',
	imports: [LucideAngularModule],
	templateUrl: './toolbar.html',
	styleUrl: './toolbar.scss',
	standalone: true
})
export class ToolbarComponent {
	rootURL = environment.rootURL;
}
